import { RootProviders } from "./provider";
import { Router } from "./router";

export const Root = () => {
  return (
    <RootProviders>
      <Router />
    </RootProviders>
  );
};
